import { MAX_CHAT_WIDTH } from '../../constants';

export default theme => ({
    topBar: {
        flex: '0 0 auto',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        minHeight: 56,
        padding: theme.spacing(1, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
    },
    topBarLeft: {
        position: 'absolute',
        left: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    grayButton: {
        textTransform: 'none',
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
        '&:hover': {
            borderColor: theme.palette.grey[400],
            backgroundColor: theme.palette.action.hover,
        },
    },
    topBarContent: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        // Shrink to avoid the button zones (spacing(26) ≈ 208px each side = spacing(52) total)
        // before hitting the MAX_CHAT_WIDTH cap.
        width: `min(${MAX_CHAT_WIDTH}px, calc(100% - ${theme.spacing(52)}))`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        minWidth: 0,
        overflow: 'hidden',
    },
    topBarTitle: {
        flex: '0 1 auto',
        minWidth: 0,
        fontWeight: 600,
        textAlign: 'center',
    },
    titleActions: {
        flex: '0 0 auto',
    },
    topBarRight: {
        position: 'absolute',
        right: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
});
